import {
  entityRisk,
  iconsAsset,
  workflowsIcons,
} from "../../stack/environment/icons/iconExport";
import { IntegrationsMapping } from "../../stack/integrations/IntegrationsMapping";

export const getIconByCategory = (parentSelectedOption, type) => {
  if (parentSelectedOption === "tool") {
    return IntegrationsMapping[type.toLowerCase()].newLogo;
  }
  if (parentSelectedOption === "severity") {
    return entityRisk[type];
  } else if (parentSelectedOption === "asset") {
    return iconsAsset[type];
  } else {
    return (
      workflowsIcons[type] ||
      workflowsIcons[parentSelectedOption] ||
      workflowsIcons.RandomWorkflowIcon
    );
  }
};
